// The web form's checkout, as the app's (mobileapp EditableForm, FormActions and
// utils/cardPaymentNote.js): the lines of the bar at the bottom, the card
// commission on top when the person pays it, and the buttons' labels.

// The commission's rate until the server's arrives (/stripe/commission-info), as in the app
export const DEFAULT_COMMISSION_RATE = Object.freeze({ percent: 0.04, fixed: 0.3 });

const round = (amount) => Math.round(amount * 100) / 100;

// What makes up the total, like the cart's lines: one per ticket asked for
export const paymentLines = (visibleTickets = [], formValues = {}) => visibleTickets.flatMap((element) => {
  if (element.type === 'ticket') {
    return formValues?.[element.id] === 0 && Number(element.price) > 0
      ? [{ key: element.id, label: element.content?.question, quantity: 1, amount: Number(element.price) }]
      : [];
  }
  return (element.content?.options || []).flatMap((option, index) => {
    const quantity = Number(formValues?.[element.id]?.[index]) || 0;
    return !option.hidden && quantity > 0 && Number(option.price) > 0
      ? [{ key: `${element.id}_${index}`, label: option.text, quantity, amount: round(quantity * Number(option.price)) }]
      : [];
  });
});

// The card commission on top of `base` when the person pays it (backend/stripe-backend.js calculateCommission)
export const cardCommission = (base, commissionMode = 'user_pays', rate = DEFAULT_COMMISSION_RATE) => (
  commissionMode === 'user_pays' && base > 0.005 ? round(base * rate.percent + rate.fixed) : 0
);

// Under the card: that it is safe and, when the person pays the commission, why it costs a little more
export const CARD_SECURITY = 'El pagament el gestiona un processador de pagaments segur: ni l\'Aleta ni la colla veuen les dades de la teva targeta.';
export const cardPaymentNote = (commissionPaidByPerson) => (commissionPaidByPerson ? [
  `${CARD_SECURITY} La colla rep l'import sencer.`,
  'La comissió es reparteix a parts iguals entre les tarifes del processador i dels bancs, i el servei de l\'Aleta, que hi cobreix pagaments fallits, devolucions i altres imprevistos.',
] : [CARD_SECURITY]);

// The main button of the screen that sends the answer
export const submitButtonLabel = ({ isSubmitting, saved, paysByCard, onPaymentStep }) => {
  if (isSubmitting) return saved ? 'Modificant...' : 'Enviant...';
  // A saved answer with something left to pay by card goes on to Stripe once changed
  if (saved) return paysByCard ? 'Modifica i paga amb targeta' : 'Modificar respostes';
  if (paysByCard) return 'Paga amb targeta';
  // After paying (a transfer, a receipt), sending says so
  return onPaymentStep ? 'He pagat, enviar respostes' : 'Enviar respostes';
};

// The greyed-out button of a form that can't be sent now. A hidden form shows none
export const unavailableSubmitLabel = ({ outdated, notOpenYet }) => {
  if (outdated) return 'Ja no es pot enviar';
  if (notOpenYet) return 'Encara no es pot enviar';
  return null;
};
